/** Cor por matéria, ciclando pelos tokens `--chart-1`..`--chart-5` pela posição no array (matéria é dado, não enum). */
const CORES_MATERIA = [
  'var(--chart-1)',
  'var(--chart-2)',
  'var(--chart-3)',
  'var(--chart-4)',
  'var(--chart-5)',
];

export function corDaMateria(materiaId: string, materias: { id: string }[]): string {
  const indice = materias.findIndex((materia) => materia.id === materiaId);
  return CORES_MATERIA[(indice < 0 ? 0 : indice) % CORES_MATERIA.length]!;
}
